import { Component, OnInit, Inject } from '@angular/core';

import { IMobileBranding } from '../../interfaces/mobile-branding';
import { MobileBrandingService } from '../../services/mobile-branding.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'mobile-branding',
  templateUrl: './mobile-branding.component.html',
  styleUrls: ['./mobile-branding.component.css'],
})
export class MobileBrandingComponent implements OnInit {
  public newMobileBrandingForm: UntypedFormGroup;
  public backgroundColor: UntypedFormControl;
  public jobListItemColor: UntypedFormControl;
  public taskListItemColor: UntypedFormControl;
  public taskDetailsItemColor: UntypedFormControl;
  public aboutItemColor: UntypedFormControl;
  public sideMenuTitle: UntypedFormControl;
  public mobileBranding: IMobileBranding;
  public hostname: string;

  constructor(private mobileBrandingService: MobileBrandingService) {
    this.hostname = window.location.protocol + '//' + window.location.host;
  }

  ngOnInit() {
    this.backgroundColor = new UntypedFormControl('');
    this.jobListItemColor = new UntypedFormControl('');
    this.taskListItemColor = new UntypedFormControl('');
    this.taskDetailsItemColor = new UntypedFormControl('');
    this.aboutItemColor = new UntypedFormControl('');
    this.sideMenuTitle = new UntypedFormControl('');

    this.newMobileBrandingForm = new UntypedFormGroup({
      backgroundColor: this.backgroundColor,
      jobListItemColor: this.jobListItemColor,
      taskListItemColor: this.taskListItemColor,
      taskDetailsItemColor: this.taskDetailsItemColor,
      aboutItemColor: this.aboutItemColor,
      sideMenuTitle: this.sideMenuTitle,
    });

    this.load();
  }

  save(formValues, event) {
    event.preventDefault();
    this.mobileBranding = {
      id: 0,
      backgroundColor: formValues.backgroundColor,
      jobListItemColor: formValues.jobListItemColor,
      taskListItemColor: formValues.taskListItemColor,
      taskDetailsItemColor: formValues.taskDetailsItemColor,
      aboutItemColor: formValues.aboutItemColor,
      sideMenuTitle: formValues.sideMenuTitle,
    };
    this.mobileBrandingService.save(this.mobileBranding);
  }

  load() {
    this.mobileBrandingService.getsupplierdetails().then((result) => {
      this.mobileBranding = result;
      this.resetFormValues();
    });
  }

  resetFormValues() {
    if (this.mobileBranding != null) {
      this.backgroundColor = new UntypedFormControl(this.mobileBranding.backgroundColor);
      this.jobListItemColor = new UntypedFormControl(this.mobileBranding.jobListItemColor);
      this.taskListItemColor = new UntypedFormControl(this.mobileBranding.taskListItemColor);
      this.taskDetailsItemColor = new UntypedFormControl(this.mobileBranding.taskDetailsItemColor);
      this.aboutItemColor = new UntypedFormControl(this.mobileBranding.aboutItemColor);
      this.sideMenuTitle = new UntypedFormControl(this.mobileBranding.sideMenuTitle);
      this.newMobileBrandingForm = new UntypedFormGroup({
        backgroundColor: this.backgroundColor,
        jobListItemColor: this.jobListItemColor,
        taskListItemColor: this.taskListItemColor,
        taskDetailsItemColor: this.taskDetailsItemColor,
        aboutItemColor: this.aboutItemColor,
        sideMenuTitle: this.sideMenuTitle,
      });
    }
  }
}
